import "./assets/css/vendor/bootstrap.min.css";
import "./assets/css/vendor/bootstrap.rtl.only.min.css";
import "react-circular-progressbar/dist/styles.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-table/react-table.css";
import "antd/dist/antd.css";
import "./assets/fonts/iconsmind-s/css/iconsminds.css";
import "./assets/fonts/simple-line-icons/css/simple-line-icons.css";

const render = () => {
  require("./AppRenderer");
};
render();
